import Full from 'Container/Full'

// component
const Gdrive = () => import('Views/settings/Gdrive')
const Settings = () => import('Views/settings/Settings')

// helpers
import { checkAuthorization, checkIp } from '../helpers/helpers.js'

export default {
  path: '/gdrive',
  component: Full,
  meta: { requiresAuth: true },
  beforeEnter(to, from, next) {
    try {
      checkAuthorization(next)
      checkIp(next)
      next()
    } catch (err) {
      console.log(err)
    }
  },
  children: [
    {
      path: '',
      component: Settings,
      children: [
        {
          path: '',
          component: Gdrive,
          meta: { title: '管理者設定' },
        },
      ],
    },
  ],
}
